<div
  class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-32 card"
  *ngIf="currentFicheConseil">
  <app-search-investisseur-autocomplete
    [isRequired]="true"
    [typePersonnes]="[currentFicheConseil.investisseurType]"
    label="Investisseur"
    [initInvestisseur]="currentFicheConseil.investisseur ?? undefined"
    (onInvestisseurPersonneSelected)="onInvestisseurPersonneSelected($event)"
    [isInvestisseurSet]="ficheConseilService.isInvestisseurLocked"
    [queryMode]="'couple'"
    #investisseurField></app-search-investisseur-autocomplete>
  <app-search-investisseur-autocomplete
    [isRequired]="true"
    label="Co-investisseur"
    [isInvestisseurSet]="ficheConseilService.isInvestisseurLocked"
    [initInvestisseur]="currentFicheConseil.coInvestisseur ?? undefined"
    [typePersonnes]="[currentFicheConseil.investisseurType]"
    *ngIf="toggleCoInvControl.value"
    (onInvestisseurPersonneSelected)="onCoInvestisseurPersonneSelected($event)"
    [conjoint]="conjoint"
    [queryMode]="'basic'"
    #coInvestisseurField>
  </app-search-investisseur-autocomplete>
  <ng-container *ngIf="(currentFicheConseil.investisseur?.id || showCoInv) && !isOneInvestisseurOnly">
    <oui-slide-toggle
      *ngIf="!ficheConseilService.isInvestisseurLocked && currentFicheConseil.investisseur?.id"
      label="Co-investisseur"
      [control]="toggleCoInvControl">
    </oui-slide-toggle
  ></ng-container>
  <app-transaction-personelle
    [currentFicheConseil]="currentFicheConseil"
    [isWithCoInvestisseur]="!!toggleCoInvControl.value"
    #transactionPersonelleStepComponent></app-transaction-personelle>
</div>
